import { CameraControls } from '@react-three/drei';
import { Canvas } from '@react-three/fiber'; // , useFrame, useLoader
import { Physics } from '@react-three/rapier';
import { useContext, useEffect } from 'react';

/* Animation */
import Explosions from '@/components/game/3d/animation/Explosions';
import FluidBackgroundCoal2 from '@/components/game/3d/animation/FluidBackgroundCoal2';
import MovingFog from '@/components/game/3d/animation/MovingFog';
/* 3d Component */
import TableBuilder from '@/components/game/3d/builder/TableBuilder';
import CameraRig from '@/components/game/3d/camera/CameraRig';
/* UI */
import AnimatedTickerToast from '@/components/game/ui/AnimatedTickerToast';
/* UI Corners */
import MetaCluster from '@/components/game/ui/corner/MetaCluster';
import PaymentCluster from '@/components/game/ui/corner/PaymentCluster';
/* Style */
import '@/style/Canvas.css';
import '@/style/UI.css';
import TickerActionCluster from '@/components/game/ui/corner/TickerActionCluster';
import TurnIndicator from '@/components/game/ui/corner/TurnIndicator';
import TurnIndicatorAbsolute from '@/components/game/ui/corner/TurnIndicatorAbsolute';
import EndgameDisplay from '@/components/game/ui/EndgameDisplay';
import GameHeader from '@/components/game/ui/GameHeader';
import ModalContainer from '@/components/game/ui/modal/ModalContainer';
import TickerWithHover from '@/components/game/ui/TickerWithHover';
import LyocTitle from '@/components/static/LyocTitle';
import LyocTitleAbsolute from '@/components/static/LyocTitleAbsolute';
import { GameContext, ViewContext } from '@/state/contexts';
import { logg } from '@/util/logg';

const Board3D = () => {
	const enableAxisHelper = false;
	const {
		currPlayer,
		players,
		playerStateArray,
		myState,

		singlePlayer,

		gameStatus,

		setSelectedAction,
		setSelectedActionCost,

		setSourceId,
		setTargetId,
		setChoiceInt,
	}: any = useContext(GameContext);

	const {
		setCamState,
		camState,

		showTicker,

		backgroundEffects,

		setPPE,
		pPE,
		setPPC,
		pPC,

		verboseUI,
		// verboseAction,
		// verboseSettings,

		// toggleVerboseAction,
		// toggleVerboseSettings,

		showTheFunny,

		viewNewsCards,
		paymentMode,
	}: any = useContext(ViewContext);

	useEffect(() => {
		if (
			playerStateArray == null ||
			currPlayer == null ||
			currPlayer.playerId == null ||
			myState == null
		) {
			return;
		}
		if (
			playerStateArray == null ||
			currPlayer == null ||
			currPlayer?.playerId == null ||
			myState.factoryEnergyArr == null ||
			myState == null ||
			myState.batteryEnergyArr == null
		) {
			return;
		}
		setPPE(
			myState.factoryEnergyArr.length + myState.batteryEnergyArr.length
		);
		setPPC(myState.carbonReserve);
		logg(`2 pPE: ${pPE} & pPC ${pPC}`);
		logg(myState.batteries >= 1 ? 2 : 1);
	}, [playerStateArray, currPlayer]);

	useEffect(() => {
		if (gameStatus > 0) {
			setCamState('spin');
		} else {
			setCamState('player');
		}
	}, [gameStatus]);

	function resetPlayerActionHooks() {
		setSelectedAction('');
		setSelectedActionCost(0);
		setSourceId(-1);
		setTargetId(-1);
		setChoiceInt(-1);
	}

	if (!playerStateArray || playerStateArray.length < 1) {
		if (
			!singlePlayer ||
			players.length <= 1 ||
			playerStateArray.length < 1
		) {
			logg('I aint got nobody to play with');
			return;
		}
		logg('Starting single player game');
	}

	/**
	 * HTML PORTION
	 */

	if (
		playerStateArray == null &&
		currPlayer == null &&
		currPlayer.playerId == null
	) {
		return;
	}

	// GAMEPLAY DISPLAY
	return (
		<>
			<ModalContainer />
			{(gameStatus === 1 || gameStatus === 2) && <EndgameDisplay />}
			{showTheFunny && (
				<iframe
					width="560"
					height="315"
					src="https://www.youtube.com/embed/dQw4w9WgXcQ?autoplay=1"
					frameBorder="0"
					allow="autoplay;"
					allowFullScreen
				></iframe>
			)}

			<div className="canvasContainer">
				<div
					className={`tickerWrapper ${showTicker ? '' : 'hidden'}`}
					aria-hidden={!showTicker}
				>
					{verboseUI && <TurnIndicator />}
					{showTicker && <TickerWithHover />}
				</div>

				<div className="threeWrapper">
					<Canvas
						frameloop="always"
						flat
						dpr={[1, 2]}
						camera={{ fov: 25, position: [0, 0, 0] }}
					>
						<CameraControls />
						<CameraRig />
						{enableAxisHelper && <axesHelper args={[20]} />}
						{gameStatus === 1 && <Explosions />}
						<color attach="background" args={['#22262a']} />

						{backgroundEffects && (
							<>
								<FluidBackgroundCoal2 />
								<MovingFog />
							</>
						)}

						<ambientLight intensity={0.2} />
						<directionalLight
							position={[5, 5, 5]}
							intensity={1.5}
						/>
						<directionalLight position={[10, 20, 45]} />
						<Physics gravity={[0, -9.81, 0]}>
							<TableBuilder
								camState={camState}
								viewNewsCards={viewNewsCards}
							/>
						</Physics>
					</Canvas>

					<AnimatedTickerToast />

					{verboseUI && (
						<>
							<LyocTitleAbsolute showImg={true} />
							{!showTicker && <TurnIndicatorAbsolute />}
						</>
					)}
					{<TickerActionCluster />}
					{paymentMode ? <PaymentCluster /> : <MetaCluster />}
				</div>
			</div>
		</>
	);
};

export default Board3D;
